<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.edit.paymentData.other.rowPayment' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px" *ngIf="dP && configProps">
    <div class="row" style="margin-left: 0px" >
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label class="roboSubTitle" for="config">{{'invoices.edit.paymentData.other.type' | translate}}</label>
            <app-select class="selectDm7" 
                [options]="configProps!.list.listCondizioniPagamento"
                [key]="'val'" [value]="'label'"
                [placeholder]="'placeholder.select' | translate" [selectedKey]="dP.CondizioniPagamento"
                (change)="dP.CondizioniPagamento = $event.key"></app-select>
        </div>
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.beneficiary' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.Beneficiario">
        </div>
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label class="roboSubTitle" for="config">{{'invoices.edit.paymentData.other.mode' | translate}}</label>
            <app-select class="selectDm7" 
                [options]="configProps!.list.listModalitaPagamento"
                [key]="'val'" [value]="'label'"
                [placeholder]="'placeholder.select' | translate" [selectedKey]="dP.DettaglioPagamento.ModalitaPagamento"
                (change)="dP.DettaglioPagamento.ModalitaPagamento = $event.key"></app-select>
        </div>
    </div>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.dateEndPay' | translate}}</label>
            <div class="input-group dm7DatePicker">
                <input class="form-control" placeholder="gg-mm-aaaa"
                        name="d1" #c2="ngModel" [(ngModel)]="dP.DettaglioPagamento.DataRiferimentoTerminiPagamento"
                        readonly
                        ngbDatepicker #d1="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important; "
                    (click)="dP.DettaglioPagamento.DataRiferimentoTerminiPagamento = '';" type="button">
                    <i class="bi bi-x-lg"></i>
                </button>
                <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button">
                    <i class="bi bi-calendar-week"></i>
                </button>
            </div>
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.dayEndPay' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.GiorniTerminiPagamento">
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label class="roboSubTitle">{{'invoices.edit.paymentData.other.dateEndPaym' | translate}}</label>
            <div class="input-group dm7DatePicker">
                <input class="form-control" placeholder="gg-mm-aaaa"
                        name="d2" #c2="ngModel" [(ngModel)]="dP.DettaglioPagamento.DataScadenzaPagamento"
                        readonly
                        ngbDatepicker #d2="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                    (click)="dP.DettaglioPagamento.DataScadenzaPagamento = '';" type="button">
                    <i class="bi bi-x-lg"></i>
                </button>
                <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                    <i class="bi bi-calendar-week"></i>
                </button>
            </div>
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.amountPayment' | translate}}</label>
            <input type="text" smart-float class="form-control" id="nL" [(ngModel)]="dP.DettaglioPagamento.ImportoPagamento">
        </div>
    </div>
    <h5 class="roboSubTitle" style="size: 18px; margin-top: 10px;">{{'invoices.edit.paymentData.other.Quietanzante' | translate}}</h5>
    <hr>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.title' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.TitoloQuietanzante">
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.surname' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.CognomeQuietanzante">
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.name' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.NomeQuietanzante">
        </div>
        
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.cf' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.CFQuietanzante">
        </div>
    </div>
    <hr>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.codUffPost' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.CodUfficioPostale">
        </div>
    </div>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.istFin' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.IstitutoFinanziario">
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.IBAN' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.IBAN">
        </div>
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.ABICAB' | translate}}</label>
            <div style="display: flex;flex-direction: row;">
                <input class="form-control" type="text" id="nL" style="border-radius: 10px 0 0 10px;" [(ngModel)]="dP.DettaglioPagamento.ABI">
                <div style="background-color: var(--backgroundGrey);width: 50px;display: flex;align-items: center;justify-content: center;border: 1px solid var(--fontColor);">/</div>
                <input class="form-control" type="text" id="nL" style="border-radius: 0px 10px 10px 0;" [(ngModel)]="dP.DettaglioPagamento.CAB">
            </div>
        </div>
        
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.paymentData.other.BIC' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dP.DettaglioPagamento.BIC">
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()">{{ 'general.save' | translate }}</button>
</div>